import { useEffect, useState } from 'react';

import type { RgbString } from '#src/lib/colors.ts';
import { getProminentColor } from '#src/lib/colors.ts';

export const useMainColor = (url: string | undefined) => {
  const [mainColor, setMainColor] = useState<RgbString>('0, 0, 0');

  useEffect(() => {
    if (url) {
      getProminentColor(url, { amount: 1 }).then(colors => {
        const [color] = colors;
        if (Array.isArray(color)) {
          setMainColor(color.join(', ') as RgbString);
        }
      });
    }
  }, [url]);

  return mainColor;
};
